import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root',
})
export class EstensaIconService {
    // constructor

    constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {}

    public initEstensaIcons() {
        this.addSvgIcon('associations-visit');
        this.addSvgIcon('chain');
        this.addSvgIcon('chain_broken');
        this.addSvgIcon('file_doc');
        this.addSvgIcon('file_pdf');
        this.addSvgIcon('file_text');
        this.addSvgIcon('files_pdf');
        this.addSvgIcon('man-woman');
        this.addSvgIcon('man');
        this.addSvgIcon('post-it');
        this.addSvgIcon('vna_study');
        this.addSvgIcon('vna_study_color');
        this.addSvgIcon('woman');
        this.addSvgIcon('outlined_feedback');
        this.addSvgIcon('ai');
        this.addSvgIcon('data_alert');
        this.addSvgIcon('STD_icon');
        this.addSvgIcon('attached_documents');
        this.addSvgIcon('reporting_icon');
        this.addSvgIcon('radiationDoseIcon');
        this.addSvgIcon('icon_invio-diagnostica');
        this.addSvgIcon('import_patient');
        this.addSvgIcon('patient_details');
        this.add3rdPartIcons();

        /* C'è un Bug noto per cui non vine importata la viewBox nell'svg, per ora imposrto i file uno per uno.
         * Se fissano il bug allora potremo importare l'intero set
         * https://github.com/NationalBankBelgium/stark/issues/455

        this.matIconRegistry.addSvgIconSet(
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/library/estensa-icons.svg")
        );
        */
    }

    private addSvgIcon(iconName: string, urlBase: string = 'assets/icons/icon_files/') {
        const url = urlBase + iconName + '.svg';
        this.matIconRegistry.addSvgIcon(iconName, this.domSanitizer.bypassSecurityTrustResourceUrl(url));
    }

    private add3rdPartIcons() {
        let url = 'assets/icons/icon_files/3rdPart/';

        this.addSvgIcon('icon_alert', url);
        this.addSvgIcon('icon_anagrafica_non_confermata', url);
        this.addSvgIcon('icon_annulla', url);
        this.addSvgIcon('icon_arrow_down', url);
        this.addSvgIcon('icon_back_arrow', url);
        this.addSvgIcon('icon_caret_down', url);
        this.addSvgIcon('icon_checkbox_check', url);
        this.addSvgIcon('icon_clock', url);
        this.addSvgIcon('icon_compara', url);
        this.addSvgIcon('icon_compara_bilancia', url);
        this.addSvgIcon('icon_cross', url);
        this.addSvgIcon('icon_empty', url);
        this.addSvgIcon('icon_eyedropper', url);
        this.addSvgIcon('icon_fab', url);
        this.addSvgIcon('icon_filtri', url);
        this.addSvgIcon('icon_filtro_rumore_1', url);
        this.addSvgIcon('icon_fit_to_screen', url);
        this.addSvgIcon('icon_full_screen', url);
        this.addSvgIcon('icon_fx', url);
        this.addSvgIcon('icon_info', url);
        this.addSvgIcon('icon_locked', url);
        this.addSvgIcon('icon_logout', url);
        this.addSvgIcon('icon_moon', url);
        this.addSvgIcon('icon_mostra_lista', url);
        this.addSvgIcon('icon_nascondi lista', url);
        this.addSvgIcon('icon_next_cell', url);
        this.addSvgIcon('icon_notification', url);
        this.addSvgIcon('icon_print', url);
        this.addSvgIcon('icon_profile', url);
        this.addSvgIcon('icon_red_star', url);
        this.addSvgIcon('icon_redo', url);
        this.addSvgIcon('icon_ruler', url);
        this.addSvgIcon('icon_refresh', url);
        this.addSvgIcon('icon_settings', url);
        this.addSvgIcon('icon_success', url);
        this.addSvgIcon('icon_suggerimenti', url);
        this.addSvgIcon('icon_sun', url);
        this.addSvgIcon('icon_undo', url);
        this.addSvgIcon('icon_unlocked', url);

        let ecgUrl = 'assets/icons/icon_files/3rdPart/Ecg/';
        this.addSvgIcon('icon_allineamento_temporale', ecgUrl);
        this.addSvgIcon('icon_calibro', ecgUrl);
        this.addSvgIcon('icon_disposizione', ecgUrl);
        this.addSvgIcon('icon_distanza_tracce', ecgUrl);
        this.addSvgIcon('icon_distanza_tracce_orizzontale', ecgUrl);
        this.addSvgIcon('icon_flusso_inverso', ecgUrl);
        this.addSvgIcon('icon_formato', ecgUrl);
        this.addSvgIcon('icon_misure', ecgUrl);
        this.addSvgIcon('icon_misure_dei_canali', ecgUrl);
        this.addSvgIcon('icon_misure_globali', ecgUrl);
        this.addSvgIcon('icon_misure_singolo_canale', ecgUrl);
        this.addSvgIcon('icon_opacita_carta', ecgUrl);
        this.addSvgIcon('icon_punti_fiduciali', ecgUrl);
        this.addSvgIcon('icon_spaziatura_tracce', ecgUrl);
        this.addSvgIcon('icon_spaziatura_tracce_orizzontale', ecgUrl);
        this.addSvgIcon('icon_velocita_carta_millimetrata', ecgUrl);
    }
}
